import { firestore } from "@/api/firebase/firebase.config";
import { useState } from "react";

const useSubmitFeedback = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const submitFeedback = async (feedback) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const feedbackRef = firestore.collection("feedback");
      await feedbackRef
        .add({
          ...feedback,
        })
        .then(() => {
          setSuccess(true);
        });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { submitFeedback, loading, error, success };
};

export default useSubmitFeedback;
